import 'reflect-metadata';

import { inject, injectable } from 'inversify';

import { User } from '@project44/ui-utils';
import {
  DtoBase,
  TenantEnums,
  TenantModels,
} from '@project44-models/iam-gateway';

import { ParametersValueObject } from '../../../shared/core/domain/ParameterValueObject';
import { ValueObject } from '../../../shared/core/domain/ValueObject';
import { SpecificTenantQuery, TenantQueryUseCase } from './useCase';

@injectable()
export class TenantService {
  constructor(
    @inject(TenantQueryUseCase)
    private readonly tenantQueryUseCase: TenantQueryUseCase,

    @inject(SpecificTenantQuery)
    private readonly specificTenantQuery: SpecificTenantQuery,
  ) {}

  public async queryTenants(
    user: User,
    parameters: ParametersValueObject<{
      tenantQueryDto: DtoBase<TenantModels.TenantQueryViewModel>;
    }>,
  ): Promise<ValueObject<DtoBase<TenantModels.TenantQueryResultsViewModel>>> {
    return this.tenantQueryUseCase.execute(user, parameters);
  }

  public async getTenantByUuid(
    userPrincipal: User,
    payload: {
      tenantStatus: TenantEnums.TenantStatusEnum;
      tenantUuid: string;
    },
  ): Promise<{ tenant: DtoBase<TenantModels.TenantViewModel> }> {
    return this.specificTenantQuery.execute(userPrincipal, payload);
  }
}
